module.exports = __webpack_public_path__ + "img/logout_icon.3ed88d4b.svg";